import Typewriter from 'typewriter-effect';

const Type = () => {

    return (
        <div  className='mt-5 mb-3 font-serif text-4xl  text-white '>
            <Typewriter 
            options={{
                strings: ['Front-End Developer', 'Web Developer', 'MERN Developer'],
                autoStart: true,
                loop: true,
            }}
        />
        </div>
    );
};

export default Type;